// NFKC (composed)             // (decomposed)
export var EtherSymbol = "\u039E"; // "\uD835\uDF63";